export default __webpack_public_path__ + "15450caf850bd56bdd6a2547e2bc2c9d.png";